import React from 'react';
import { Main } from '../Components';

export const Home = () => <Main />;
